import PropTypes from 'prop-types';

import { flattenImageAsset } from '../../lib/contentful/selectors';
import PlatformCheck, { PLATFORMS } from '../../components/PlatformCheck';
import Link from '../../components/Link';
import { CloudinaryImage } from '../../components/CloudinaryImage';

import styles from './styles.module.scss';

const StoreBadge = ({ badge, onClick, className }) => {
  return (
    <PlatformCheck allowed={badge.allowedPlatforms}>
      {(platform) => {
        const badgeLink = badge[platform == 'desktop' ? 'desktop' : 'mobile'];
        return (
          <Link
            link={badgeLink}
            target="_blank"
            className={className}
            id={badgeLink?.fields?.id}
            onClick={onClick}
          >
            {!!badge.image && (
              <CloudinaryImage
                {...flattenImageAsset(badge.image)}
                className={styles.image}
              />
            )}
          </Link>
        );
      }}
    </PlatformCheck>
  );
};

StoreBadge.propTypes = {
  badge: PropTypes.shape({
    image: PropTypes.object.isRequired,
    mobile: PropTypes.object,
    desktop: PropTypes.object,
    allowedPlatforms: PropTypes.arrayOf(PropTypes.oneOf(PLATFORMS)),
  }).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default StoreBadge;
